export const PATH_NAME = Object.freeze({
  // Private routes
  LEADERBOARD: "/app/leaderboard",
  ACCOUNT: "/app/account",
  NEWS_FEED: "/app/newsfeed",
  HOME_PAGE: "/app",
  WORKSPACE: "/app/workspace",
  BILLING: "/app/billing",
  SETTINGS: "/app/settings", // Legacy — redirects to WORKSPACE
  CUSTOMIZATION: "/app/customization",
  LOGIN: "/login",
  INSIGHTS: "/app/insights",
  PUBLIC_PROFILE: "/public_profile",
  HELP_CENTER: "/help_center",
  ADMIN: "/app/admin",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  LANDING_PAGE: "/",
  BLOG: "/blog",
  BLOG_DETAIL: "/blog/:id",
  OVERVIEW_DASHBOARD: "/app/analytics/overview",
  EMPLOYEE_INSIGHTS: "/app/analytics/employee-insights",
  TEAM_ANALYSIS: "/app/analytics/team-analysis",
  RECOGNITION_TRENDS: "/app/analytics/recognition-trends",
  LOW_ENGAGEMENT: "/app/analytics/low-engagement",
  // Actions/Awards feature
  ACTIONS: "/app/actions",
  SUBMIT_CLAIM: "/app/actions/submit",
  MY_CLAIMS: "/app/actions/my-claims",
  ADMIN_CLAIMS: "/app/admin/claims" // Legacy — redirects to WORKSPACE?tab=1
});
